import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetCategoryDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Category/GetDetail?` + params, null);

export const GetCategoryList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Category/GetList?` + params, null);

export const CreateCategory = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Category/Create`, data);

export const UpdateCategory = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Category/Update`, data);    

export const DeleteCategory = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Category/Delete`, data);
